// extracted by mini-css-extract-plugin
export default {"layer":"SoilLayer_layer__cDs7J","hiddenLayer":"SoilLayer_hiddenLayer__v5d-P"};